import React from "react";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import LastLog from "app/views/custom/components/Logs/LastLog";
// import ManagementTable from "app/Components/ManagementTable/ManagementTable";
import { departmentApis } from "./Constant";
import TableWithServerSide from "app/Components/TableWithServerSide/TableWithServerSide";

class Department extends React.Component {
  columns = [
    {
      dataField: "name",
      text: "Department Name",
      sort: true,
    },
  ];

  render() {
    return (
      <div>
        <MainBreadcrumb
          routeSegments={[
            { name: "User Management", path: "#" },
            { name: "Department", path: "#" },
          ]}
          breadCrumbsText="User_Management_Department"
        />
        <div className="card p-4 mb-4">
          <TableWithServerSide
            title="Department"
            columns={this.columns}
            apis={departmentApis}
            tableName="departments"
            viewLink={"/user-management/department/view/"}
            editLink={"/user-management/department/edit/"}
            addLink={"/user-management/department/add/"}
            withApproveReject
          />
        </div>
        <LastLog subModulename={"departments"}></LastLog>
      </div>
    );
  }
}

export default Department;
